import Sentry, { BrowserOptions } from "@similarweb/sentry-logger";

import { createBaseConfig, NETWORK_RESPONSE_HEADERS_WHITE_LIST, DENY_URLS } from "./base-config";

const createIntegrationConfig = (buildId: string): BrowserOptions => {
    const baseConfig = createBaseConfig(buildId);
    const NETWORK_DETAILS_URLS_WHITE_LIST = [/https:\/\/[^-]+-(gro|pro)\.sandbox\.similarweb\.com/];

    return {
        ...baseConfig,
        debug: true,
        environment: "Integration",
        sampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            Sentry.integrations.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
                stickySession: true,
                networkDetailAllowUrls: NETWORK_DETAILS_URLS_WHITE_LIST,
                networkResponseHeaders: NETWORK_RESPONSE_HEADERS_WHITE_LIST,
            }),
        ],
        denyUrls: DENY_URLS,
    };
};

export default createIntegrationConfig;
